// src/components/layout/AuthLayout.jsx
import { Outlet, Link } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-4 py-12">
      <Link to="/" className="mb-8">
        <span className="font-syne font-extrabold text-2xl text-gradient">Fabrinza</span>
      </Link>
      <div className="w-full max-w-md">
        <Outlet />
      </div>
      <p className="mt-8 text-xs text-muted">
        © {new Date().getFullYear()} Fabrinza · <Link to="/pages/privacy-policy" className="hover:text-pink">Privacy</Link> · <Link to="/pages/terms" className="hover:text-pink">Terms</Link>
      </p>
    </div>
  )
}
